function numToLocale(value) {
    return value.toLocaleString(undefined, { maximumFractionDigits: 2 });
}
/**
 * Electricity (number provided in kWh)
 *
 * * input > 1,000,000 use MWh
 * * input > 100,000,000 use GWh
 *
 * @returns formatted string of number + unit
 */
export function formatElec(value) {
    if (value >= 100000000) {
        return numToLocale(value / 1000000) + " GWh";
    }
    if (value >= 1000000) {
        return numToLocale(value / 1000) + " MWh";
    }
    return numToLocale(value) + " kWh";
}
/**
 * Gas (number provided in kJ)
 *
 * * input > 100,000 use MJ
 * * input > 1,000,000 use GJ
 *
 * @returns formatted string of number + unit
 */
export function formatGas(value) {
    if (value >= 1000000) {
        return numToLocale(value / 1000000) + " GJ";
    }
    if (value >= 100000) {
        return numToLocale(value / 1000) + " MJ";
    }
    return numToLocale(value) + " kJ";
}
/**
 * Water (number provided in kL)
 *
 * * input > 100,000 use ML
 * * input > 1,000,000 use GL
 *
 * @returns formatted string of number + unit
 */
export function formatWater(value) {
    if (value >= 1000000) {
        return numToLocale(value / 1000000) + " GL";
    }
    if (value >= 100000) {
        return numToLocale(value / 1000) + " ML";
    }
    return numToLocale(value) + " kL";
}
//# sourceMappingURL=formatConsumption.js.map